import * as Yup from "yup";

export const permissionValidator = Yup.object().shape({
  name: Yup.string().required("กรุณากรอก"),
  description: Yup.string().required("กรุณากรอก"),
});
